import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router-dom'

import { Button, theme } from '@acorns/grove'
import { AcornsIcon } from '@acorns/icons'
import { useAnalyticsClient } from '@acorns/web-utils'
import styled from 'styled-components'

import { trackAiChatDeeplinkButtonTappedPayload } from 'generated/trackingEvents'
import { ChatDeeplink } from 'generated/types'

import { AI_CHAT_FEEDBACK_ORIGIN } from './utils/constants'

const StyledBase = styled.div`
  position: relative;
  left: 50px;
  cursor: pointer;
  width: fit-content;
  border: 1px solid ${theme.colors.primaryIvory};
  border-radius: ${theme.borderRadius.large};
  max-width: calc(100% - 60px);
  margin-bottom: 20px;
  margin-top: 10px;

  > button {
    margin-bottom: 10px;
  }

  > button:last-of-type {
    margin-bottom: 0px;
  }
`

const LinkIcon = styled(AcornsIcon)`
  width: 24px;
  height: 24px;
  margin-right: 4px;
  & path {
    fill: ${theme.colors.primaryWhite};
  }
`

export const DEEPLINK_VALIDATION_REGEX =
  /^https:\/\/app(\.[a-zA-Z0-9-]+)?\.acorns\.(io|com)(\/.*)?$/

const DeepLinks = ({
  deeplinks,
  onCloseAssistant,
}: {
  deeplinks: ChatDeeplink[]
  onCloseAssistant: () => void
}) => {
  const { track } = useAnalyticsClient()
  const history = useHistory()
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.dimensions.breakpointsSmall}px)`,
  })
  const handleClick = (deeplink: ChatDeeplink) => () => {
    const { title, url } = deeplink

    const match = url.match(DEEPLINK_VALIDATION_REGEX)

    track(
      ...trackAiChatDeeplinkButtonTappedPayload({
        origin: AI_CHAT_FEEDBACK_ORIGIN,
        ctaTitle: title,
        url,
      }),
    )

    if (match) {
      const urlObject = new URL(url)
      history.push(urlObject.pathname)
    } else {
      window.open(url, '_blank')
    }
    if (isMobile) {
      onCloseAssistant()
    }
  }

  return (
    <StyledBase>
      {deeplinks.map((deeplink) => (
        <Button
          key={`${deeplink.title}-${deeplink.url}`}
          onClick={handleClick(deeplink)}
        >
          <LinkIcon icon={AcornsIcon.Icon.UtilityShareLinkFv} />
          {deeplink.title}
        </Button>
      ))}
    </StyledBase>
  )
}

export { DeepLinks }
